import {type StoreItemCategory} from '../../../../shared/entity_datas/StoreEnums.ts'
import {type BaseStoreItem} from '../../../../shared/store/BaseStoreItem.ts'
import {type ColonistMembershipProduct} from '../../../../shared/store/ColonistMembershipProduct.ts'
import {type UIMembershipProductView} from './UIMembershipProductView.ts'
import {type UIStoreMembershipTabsController} from './UIStoreMembershipTabsController.ts'
import {type GiftedMembershipItem} from '../../../../shared/store/UserItems.ts'
import {PaymentMethod} from '../../../../shared/store/BaseColonistStoreProduct.ts'
import {type UIStoreGiftOverlayController} from './gift/UIStoreGiftOverlayController.ts'
import {setElementInnerHTML} from '../ui_utils/DomUtils.ts'
import {UIStoreReferralController} from './UIStoreReferralController.ts'
import {type ReferralReward} from '../../../../shared/ReferralProgram.ts'

export abstract class UIStoreBodyController {
    readonly membershipItems: UIMembershipProductView[] = []
    giftOverlayController: UIStoreGiftOverlayController
    abstract readonly membershipTabsController: UIStoreMembershipTabsController
    protected readonly referralSection: HTMLDivElement
    protected readonly referralItemsDiv: HTMLDivElement
    protected readonly referralInfoDiv: HTMLDivElement
    protected readonly referralSidebarButton: HTMLDivElement
    protected readonly referralTabMobile: HTMLDivElement
    private readonly referralController: UIStoreReferralController

    constructor() {
        setTimeout(() => {
            const membershipTitle = document.getElementById('store_page_membership_title')
            if(membershipTitle == undefined) return
            setElementInnerHTML(membershipTitle, {key: 'strings:storePage.sections.membership.title'})
        }, 100)

        this.referralController = new UIStoreReferralController(this)
    }

    abstract updateCategoryItems(category: StoreItemCategory, container: HTMLDivElement)
    abstract updateOwnedItems(ownedItems: BaseStoreItem[])
    abstract updateSubscribedItems(ownedMembership: ColonistMembershipProduct | undefined, paymentMethod: PaymentMethod | undefined)
    abstract updateOwnedMembership(ownedMembership: ColonistMembershipProduct | undefined, paymentMethod: PaymentMethod | undefined)
    abstract updatePriceForFounderPack(ownedItems: BaseStoreItem[])
    abstract updateGiftedMemberships(memberships: GiftedMembershipItem[])
    abstract onInviteFriendsButtonClick(referralReward: ReferralReward, userReferralCount: number)

    // eslint-disable-next-line class-methods-use-this
    protected shouldDisableMembershipManagement(paymentMethod: PaymentMethod | undefined): boolean {
        const isStripe = paymentMethod == PaymentMethod.Stripe
        const isIAP = paymentMethod == PaymentMethod.Apple || paymentMethod == PaymentMethod.Android
        const disableMembershipManagement = !isStripe && !isIAP
        return disableMembershipManagement
    }

    // eslint-disable-next-line class-methods-use-this
    setupReferralRewardClickHandler(contentDiv: HTMLDivElement, description: HTMLParagraphElement, image: HTMLImageElement, referralReward: ReferralReward) {
        window.addEventListener('click', (event: MouseEvent) => {
            if(UIStoreReferralController.isDescriptionAlreadyDisplayed(description)) {
                UIStoreReferralController.displayImageInsteadOfDescription(description, image)
                return
            }
            if(UIStoreReferralController.isClickOnTheItem(event, contentDiv)) UIStoreReferralController.displayDescriptionInsteadOfImage(description, image)
        })
    }

    async updateReferralProgram() {
        await this.referralController.updateReferralProgram()
    }
}
